module.exports = __webpack_public_path__ + "static/media/t_3.16669904.jpg";